import { validateToken } from '@/common/api';
import { storageService } from '@/services/storage-service';
import { handleError } from '@/common/errors';

const TOKEN_KEY = 'token';

class TokenService {
  static getToken() {
    return storageService.get(TOKEN_KEY);
  }

  static setToken(token: string) {
    storageService.set(TOKEN_KEY, token);
  }

  static clearToken() {
    storageService.del(TOKEN_KEY);
  }

  static async validateToken() {
    const token = this.getToken();

    if (!token) return false;

    try {
      const response = await validateToken(token);
      return response.data.valid;
    } catch (error: unknown) {
      handleError(error, 'Failed to validate token');
      return false;
    }
  }
}

export default TokenService;
